import { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

function splitKey(secret) {
  if (!secret) return [];
  return secret.match(/.{1,4}/g) || [];
}

export default function TotpManualKey({ secret, className = '' }) {
  const { t } = useTranslation();
  const [revealed, setRevealed] = useState(false);
  const [shownSecret, setShownSecret] = useState(secret);
  const groups = splitKey(secret);

  // Each secret is revealed on purpose: reset while rendering so a new one never paints unmasked.
  if (secret !== shownSecret) {
    setShownSecret(secret);
    setRevealed(false);
  }

  return (
    // surface-raised / divider-soft have no dark value, so without the dark: pair
    // the box stays near-white while text-primary turns white.
    <div
      className={`rounded-lg border border-solid border-muted bg-surface-hover px-3.5 py-2.5 text-center dark:border-border dark:bg-surface ${className}`.trim()}>
      <p className="m-0 mb-1 font-sans text-[9.5px] font-bold uppercase tracking-[0.12em] text-muted">
        {t('heimdal_app.TOTP.cant_scan')}
      </p>
      <div className="flex items-center justify-center gap-2">
        <p
          className={`m-0 font-mono text-[12.5px] font-semibold tracking-[0.15em] ${
            revealed ? 'text-primary' : 'text-secondary'
          }`}>
          {groups.map((group, i) => (
            <span key={i}>
              {i > 0 ? <span className="text-accent">{' · '}</span> : null}
              {revealed ? group : '*'.repeat(group.length)}
            </span>
          ))}
        </p>
        <button
          type="button"
          onClick={() => setRevealed(prev => !prev)}
          aria-label={t(revealed ? 'heimdal_app.TOTP.hide_key' : 'heimdal_app.TOTP.show_key')}
          aria-pressed={revealed}
          className="flex shrink-0 cursor-pointer items-center justify-center border-0 bg-transparent p-1 text-muted transition-colors hover:text-accent">
          <IconComponent
            iconName={revealed ? 'eye-off-outline' : 'eye-outline'}
            style={{ fontSize: 16 }}
          />
        </button>
      </div>
    </div>
  );
}

TotpManualKey.propTypes = {
  secret: PropTypes.string,
  className: PropTypes.string,
};
